import React from 'react'
import Link from 'next/link'
import cl from 'classnames'

import styles from './styles.module.scss'
import { Divider } from '@components/divider'
import { Tag } from 'types/article'

type TagsProps = Omit<Tag, 'id' | 'slug' | 'parent'>

interface Props {
  tags: TagsProps[]
  className?: string
}

export const TagsCloud = (props: Props) => {
  const { tags, className } = props
  return (
    <div className={cl(className)}>
      <div>
        <Divider type="primary" orientation="horizontal" />
      </div>
      <div className={styles.container}>
        {tags?.map((tag, index) => (
          <React.Fragment key={index}>
            <div className={styles.content}>
              <Link
                key={tag.path}
                href={`/${
                  tag.path.charAt(0) === '/'
                    ? tag.path.replace('/', '')
                    : tag.path
                }`}
                className={styles.link}
              >
                {tag.name}
              </Link>
            </div>
            {!(index + 1 === tags.length) && (
              <div className={styles.separator}></div>
            )}
          </React.Fragment>
        ))}
      </div>
      <div>
        <Divider type="primary" orientation="horizontal" />
      </div>
    </div>
  )
}
